<ul class="tag-list">
  <li *ngFor="let tag of tagsProps" class="tag-default tag-pill tag-outline">
    {{ tag }}
  </li>
</ul>
